import React from "react";
import { CircleMarker, Polyline, Tooltip } from "react-leaflet";

function mappedAgo(iso) {
  if (!iso) return null;
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms) || ms < 0) return null;
  const h = ms / 36e5;
  if (h < 1) return `mapped ${Math.max(1, Math.round(ms / 6e4))}m ago`;
  if (h < 48) return `mapped ${Math.round(h)}h ago`;
  return `mapped ${Math.round(h / 24)}d ago`;
}

export const FollowedFiresLayer = ({ fires = [] }) => (
  <>
    {fires.map((f) => (
      <React.Fragment key={`followed-${f.id}`}>
        <CircleMarker
          center={[f.latitude, f.longitude]}
          radius={16}
          pathOptions={{
            color: "#F2542D",
            weight: 2.5,
            fill: false,
            className: "followed-pulse",
          }}
        />
        {f.ref && (
          <Polyline
            positions={[
              [f.ref.ref_lat, f.ref.ref_lon],
              f.edge ? [f.edge.lat, f.edge.lon] : [f.latitude, f.longitude],
            ]}
            pathOptions={{ color: "#F2542D", weight: 2, opacity: 0.7, dashArray: "4 8" }}
          >
            <Tooltip permanent direction="center" className="followed-dist-label">
              <div style={{ textAlign: "center", lineHeight: 1.25 }}>
                <div>{(f.edge ? f.edge.distance_mi : f.ref.distance_mi).toFixed(1)} mi</div>
                {f.edge && <div>to edge</div>}
                {f.edge && mappedAgo(f.edge.mapped_at) && (
                  <div style={{ fontSize: 10, fontWeight: 600, opacity: 0.8 }}>
                    {mappedAgo(f.edge.mapped_at)}
                  </div>
                )}
              </div>
            </Tooltip>
          </Polyline>
        )}
      </React.Fragment>
    ))}
  </>
);

export default FollowedFiresLayer;
